import base from '../httpApi/base'; // 导入接口域名列表
import axios from '../httpApi/http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块
import { param } from 'jquery';
const permissionApi = {
    UpdateMenu(params) {
        return axios.put(`${base.dev}/services/app/AdminSGLRole/UpdateMenuSystemList`, params)
    },
    getAllMenu(params) {
        return axios.get(`${base.dev}/services/app/AdminSGLMenu/getMenuSystem`, { params })
    },
    getRoleMenu(params) {
        return axios.get(`${base.dev}/services/app/AdminSGLMenu/GetRolseByMenu`, { params })
    },
    getMenu(params) {
        return axios.get(`${base.dev}/services/app/AdminSGLMenu/GetUserRolseMenu`, { params })
    },
    getFootAll(params) {
        return axios.get(`${base.dev}/services/app/Foot/GetAll`, { params })
    },
    getFootDetailInfo(params) {
        return axios.get(`${base.dev}/services/app/Foot/getContent`, { params })
    },
    getFootContentInfo(params) {
        return axios.get(`${base.dev}/services/app/AdminFootContent/Get`, { params })
    },
    editFootContentInfo(params) {
        return axios.put(`${base.dev}/services/app/AdminFootContent/Update`, params)
    },
    deleteFootContentInfo(params) {
        return axios.delete(`${base.dev}/services/app/AdminFootContent/Delete`, { params })
    },
    GetFootContentList(params) {
        return axios.get(`${base.dev}/services/app/AdminFootContent/GetAll`, { params })
    },
    GetFootContentList2(params) {
        return axios.post(`${base.dev}/services/app/Foot/GeContenttAll`, params)
    },
    createFootContent(params) {
        return axios.post(`${base.dev}/services/app/AdminFootContent/Create`, params)
    },
    updateFootOrder(params) {
        return axios.post(`${base.dev}/services/app/AdminFoot/UpdateStore`, params)
    },
    deleteFootInfo(params) {
        return axios.delete(`${base.dev}/services/app/AdminFoot/Delete`, { params })
    },
    editFootInfo(params) {
        return axios.put(`${base.dev}/services/app/AdminFoot/Update`, params)
    },
    getFootInfo(params) {
        return axios.get(`${base.dev}/services/app/AdminFoot/Get`, { params })
    },
    createFoot(params) {
        return axios.post(`${base.dev}/services/app/AdminFoot/Create`, params)
    },
    GetFootList(params) {
        return axios.get(`${base.dev}/services/app/AdminFoot/GetAll`, { params })
    },
    GetLogList(params) {
        return axios.get(`${base.dev}/services/app/AdminLogManage/GetAll`, { params })
    },
    //獲取所有權限
    GetAllPermission() {
        return axios.get(`${base.dev}/services/app/AdminSGLMenu/GetMenuPermissionList`)
    },
    //添加角色
    AddRolePermissions(params) {
        return axios.post(`${base.dev}/services/app/AdminSGLRole/Create`, params)
    },
    //角色列表
    GetAllRole() {
        return axios.get(`${base.dev}/services/app/AdminSGLRole/GetAll`)
    },
    GetRole(params) {
        return axios.get(`${base.dev}/services/app/AdminSGLRole/Get`, { params })
    },
    updateRole(params) {
        return axios.put(`${base.dev}/services/app/AdminSGLRole/Update`, params)
    },
    //删除角色列表
    DeleteRole(params) {
        return axios.delete(`${base.dev}/services/app/AdminSGLRole/Delete`, { params: params })
    },
    //獲取所有用戶
    GetUserList(params) {
        return axios.get(`${base.dev}/services/app/AdminMemEmber/GetUsers`, { params })
    },
    //根據id獲取用戶信息
    getUser(params) {
        return axios.get(`${base.dev}/services/app/AdminMemEmber/Get`, { params })
    },
    UpdateUser(params) {
        return axios.put(`${base.dev}/services/app/AdminMemEmber/Update`, params)
    },
    //獲取所有留言
    getCommentAll(params) {
        return axios.get(`${base.dev}/services/app/AdminMessage/GetAll`, { params })
    },
    //隱藏評論
    updateComment(params) {
        return axios.put(`${base.dev}/services/app/AdminMessage/Update
        `, params)
    },
    //Banner图
    getBannerList(params) {
        return axios.post(`${base.dev}/services/app/AdminBanner/GetAll`, params)
    },
    getBannerInfo(params) {
        return axios.get(`${base.dev}/services/app/AdminBanner/Get`, { params })
    },
    createBannerInfo(params) {
        return axios.post(`${base.dev}/services/app/AdminBanner/Create`, params)
    },
    updateBannerInfo(params) {
        return axios.put(`${base.dev}/services/app/AdminBanner/Update`, params)
    },
    deleteBanner(params) {
        return axios.delete(`${base.dev}/services/app/AdminBanner/Delete`, { params: params })
    },
    //dashboard
    getVNewYesterdayAdded(params) {
        return axios.get(`${base.dev}/services/app/AdminMemEmber/GetVNewYesterdayAdded`, { params })
    },
    getYestDay(params) {
        return axios.get(`${base.dev}/services/app/AdminMemEmber/getYestDay`, { params })
    },
    getYestDayStatistics(params) {
        return axios.get(`${base.dev}/services/app/AdminMemEmber/getYestDayStatistics`, { params })
    },
    getComputerService(params) {
        return axios.post(`${base.dev}/services/app/AdminMemEmber/ComputerService`, params)
    },
    getUploadPhotoCount(params) {
        return axios.post(`${base.dev}/services/app/AdminPhotoGalleryConfigAppSerivce/UploadPhotoCount`, params)
    },
}
export default permissionApi


// WEBPACK FOOTER //
// ./src/api/Permission/PermissionApi.js